import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['source', 'toggleable']
  static values = {
    match: Array,
    allowBlank: { type: Boolean, default: true },
    validity: { type: Boolean, default: true },
  }

  connect() {
    this.toggle();
  }

  toggle() {
    if (!this.hasSourceTarget || !this.hasMatchValue || !this.validityValue) return;

    if (this.matchValue.includes(this.sourceTarget.value) || (this.allowBlankValue && this.sourceTarget.value === "")) {
      this.toggleableTarget.classList.add('d-none');
    } else {
      this.toggleableTarget.classList.remove('d-none');
    }
  }
}
